import { initSearchableDropdowns } from '../../components/searchable_dropdown'

function initDashboard() {
  document.addEventListener('htmx:afterSwap', function () {
    if (document.querySelector('select[data-searchable="true"]')) {
      initSearchableDropdowns()
    }
  })
}

export { initDashboard }
